// extracted by mini-css-extract-plugin
export default {"button":"eo-z","reviewSort":"fo-z"};